import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/services/shared/global.service';
import { CategoriesService } from 'src/app/services/cash-management/categories.service';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-edit-cash-category',
  templateUrl: './edit-cash-category.component.html',
  styleUrls: ['./edit-cash-category.component.css']
})
export class EditCashCategoryComponent implements OnInit{
  form!: FormGroup;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;
  public Id: string | null = null;
  public categoryData:any;

  constructor(
    private categoriesService:CategoriesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private activatedRoute: ActivatedRoute,
  ){
    this.form = this.formBuilder.group({
      category_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.Id = param['get']('id')
    })

    if(this.Id){
      this.fetchCategoryData(this.Id);
    }else{
      //Navigate back to categories list with error
      this.globalService.setGlobalErrorMessage("Unable to select category for editing!");
      this.router.navigate(['cash-mgnt/categories-list']);
    }
  }

  /**
   * Get category data
   * @param Id 
   */
  fetchCategoryData(Id: string): void {
    this.categoriesService.edit(Id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.categoryData = response;
          if(this.categoryData.status==='no_data' || this.categoryData.status.length===0){
            this.errorMessage=this.categoryData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.categoriesService.update(formData,this.Id).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);
         
          // Redirect back to categories ist
          this.router.navigate(['cash-mgnt/categories-list']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
